import styled from 'styled-components'

const ListHolder = styled.div`
  border-bottom: solid 1px #d5d5d7;
`

export default ListHolder
